// document.addEventListener("load", () => {
//   gsap.registerPlugin(ScrollTrigger);

//     gsap.from("#layers-nexora-os .top-content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#layers-nexora-os .top-content",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true
//         },
//     });

//     gsap.from("#canvas-ai .nexora_banner_content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#canvas-ai .nexora_banner_content",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true
//         },
//     });

//     gsap.from("#layers-ai .top-content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#layers-ai .top-content",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true
//         },
//     });

//     gsap.from("#design-highlights .design-content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#design-highlights .design-content",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true
//         },
//     });

//     gsap.from("#fast-brilliant .nexora_banner_content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#fast-brilliant .nexora_banner_content",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true
//         },
//     });

//     gsap.from("#built-in-gps .image-with-text__text-item.grid__item", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#built-in-gps .image-with-text__text-item.grid__item",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true
//         },
//     });

//     gsap.from("#new-upgrade-sensor .nexora_banner_content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#new-upgrade-sensor .nexora_banner_content",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true
//         },
//     });

//     gsap.from("#hi-silicon .nexora_banner_content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#hi-silicon .nexora_banner_content",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true,
//         },
//     });    

//     gsap.from("#power-display .image-with-text__content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#power-display .image-with-text__content",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true
//         },
//     }); 
    
//     gsap.from("#index-watch-face .video-section-header", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#index-watch-face .video-section-header",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true
//         },
//     }); 

//     gsap.from("#homepage .buynow_data_container", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//         trigger: "#homepage .buynow_data_container",
//         start: "top 70%",
//         end: "top 20%",
//         scrub: true
//         },
//     }); 

//     setTimeout(() => {
//         ScrollTrigger.refresh();
//     }, 2000);
// })

gsap.registerPlugin(ScrollTrigger);

const targets = [
  "#layers-nexora-os .top-content",
  // "#canvas-ai .nexora_banner_content",
  // "#layers-ai .top-content",
  // "#design-highlights .design-content",
  // "#fast-brilliant .nexora_banner_content",
  // "#built-in-gps .image-with-text__text-item.grid__item",
  // "#new-upgrade-sensor .nexora_banner_content",
  // "#hi-silicon .nexora_banner_content",
  // "#power-display .image-with-text__content",
  // "#index-watch-face .video-section-header",
  // "#homepage .buynow_data_container",
];

if (window.matchMedia("(max-width: 749px)").matches) {
  targets.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      gsap.fromTo(
        el,
        { opacity: 0.5, y: 40 },
        {
          opacity: 1,
          y: 0,
          ease: "none",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            end: "top 20%",
            scrub: true,
            invalidateOnRefresh: true,
          },
        }
      );
    });
  });
}

ScrollTrigger.config({ ignoreMobileResize: true });
window.addEventListener("load", () => ScrollTrigger.refresh());
document.querySelectorAll("img").forEach((img) => {
  if (!img.complete) {
    img.addEventListener("load", () => ScrollTrigger.refresh(), { once: true });
  }
});
document.fonts?.ready.then(() => ScrollTrigger.refresh());